export interface IMapZoomState {
  zoom: number;
  minZoom: number;
  maxZoom: number;
}

export const initialMapZoomState: IMapZoomState = {
  zoom: 0,
  minZoom: 0,
  maxZoom: 0
}
